import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FlexContainer, InlineBox, Typography } from '@rappi/rests-commons-front';
import { lazy, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { commercialProcessesService } from '../../../../../services/commercial-processes.service';
import { BottomBar } from '../../bottom-bar/bottom-bar';
const FileViewer = lazy(() => import('storesetupapp/components/FileViewer'));
export const Confirm = ({ goNext, goBack, step, data, mode, isFinalizingProcess }) => {
    var _a;
    const { t } = useTranslation();
    const { key } = step;
    const { files } = data;
    const [contractFile, setContractFile] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const contractData = (files === null || files === void 0 ? void 0 : files.SIGNED_CONTRACT) || (files === null || files === void 0 ? void 0 : files.UNSIGNED_CONTRACT);
    useEffect(() => {
        var _a;
        if (contractData && !contractFile) {
            setIsLoading(true);
            commercialProcessesService
                .getCommercialProcessFileById(contractData.id.toString(), (_a = contractData.file_details.type) !== null && _a !== void 0 ? _a : 'contract', contractData.file_details.additional_data.extension)
                .then((file) => {
                setContractFile(file);
            })
                .catch((error) => {
                console.log(error);
            })
                .finally(() => {
                setIsLoading(false);
            });
        }
    }, [files]);
    return (_jsxs(FlexContainer, { direction: "column", gap: 24, children: [_jsx(Typography, { component: "headline", children: t(`commercialProcess.steps.${key}.title`) }), _jsx(InlineBox, { body: _jsxs(FlexContainer, { direction: "column", gap: 8, children: [_jsx(Typography, { component: "body", semibold: true, children: mode === 'only-view'
                                ? t(`commercialProcess.steps.${key}.reviewTitle`)
                                : t(`commercialProcess.steps.${key}.lastStepTitle`) }), _jsx(Typography, { component: "body", children: mode === 'only-view'
                                ? t(`commercialProcess.steps.${key}.reviewDescription`)
                                : t(`commercialProcess.steps.${key}.lastStepDescription`) })] }) }), contractData && (_jsx(FlexContainer, { maxWidth: "600px", width: "600px", margin: "0 auto", direction: "column", gap: 16, children: _jsx(FileViewer, { isLoading: isLoading, files: [
                        {
                            file: contractFile !== null && contractFile !== void 0 ? contractFile : undefined,
                            name: contractFile === null || contractFile === void 0 ? void 0 : contractFile.name,
                        },
                    ] }, (_a = contractFile === null || contractFile === void 0 ? void 0 : contractFile.name) !== null && _a !== void 0 ? _a : 'contract') })), _jsx(BottomBar, { backButton: {
                    onClick: goBack,
                    text: t('back'),
                    variant: 'secondary',
                }, nextButton: {
                    loading: isFinalizingProcess,
                    onClick: goNext,
                    text: mode === 'only-view'
                        ? t(`commercialProcess.steps.${key}.close`)
                        : t(`commercialProcess.steps.${key}.finish`),
                } })] }));
};
